export const isAuthOrRoleFailure = (error: unknown): boolean => {
    if (!error || typeof error !== 'object') {
        return false;
    }

    const status = (error as { status?: unknown }).status;
    if (status === 401 || status === 403) {
        return true;
    }

    const message = (error as { message?: unknown }).message;
    if (typeof message === 'string') {
        return /\b(401|403)\b/.test(message);
    }

    return false;
};
